import { auth, usersRef, GoogleProvider, setBusinessUser } from "@/fireinit.js";
import router from "@/router";
import axios from "axios";
import Vue from "vue";

export default {
  passwordReset({ commit }, email) {
    auth.sendPasswordResetEmail(email);
  },
  signIn: ({ commit, dispatch, rootState, state }, user) => {
    if (user.method === "email") {
      return auth
        .signInWithEmailAndPassword(user.email, user.password)
        .then(async (authUser) => {
          commit("setUser", { auth: authUser });
          dispatch("loadUserData");
          if (state.redirect != "") {
            router.push(state.redirect);
            commit("setRedirect", "");
          } else {
            router.push("/admin/dashboard");
          }
        })
        .catch((error) => {});
    } else if (user.method === "newUser") {
      return auth
        .createUserWithEmailAndPassword(user.email, user.password)
        .then(async (authUser) => {
          await commit("setUser", { auth: authUser });

          let newUserApiData = {
            firebase_id: authUser.user.uid,
            email: user.email,
          };
          await axios
            .post(`${rootState.axios.API}user/create`, newUserApiData)
            .then(() => {
              dispatch("loadUserData");
            });
        });
    } else if (user.method === "google") {
      return auth.signInWithPopup(GoogleProvider).then(async (authUser) => {
        commit("setUser", { auth: authUser });
        dispatch("loadUserData");
        if (state.redirect != "") {
          router.push(state.redirect);
          commit("setRedirect", "");
        } else {
          router.push("/admin/dashboard");
        }
      });
    }
  },
  saveUserProfile: async ({ commit, dispatch, rootState }, data) => {
    if (data.business_id == "") {
      data.business_id = null;
    }
    if (data.impactBusiness_id == "") {
      data.impactBusiness_id = null;
    }
    let updateUser = await axios.post(
      `${rootState.axios.API}user/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    dispatch("loadUserData");
  },
  loadUsers: async ({ commit, rootState }) => {
    let usersList = [];
    const response = await axios.get(`${rootState.axios.API}user/all`, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    response.data.forEach((user) => {
      usersList.push({ ...user });
    });
    commit("setUsersList", usersList);
  },
  loadUserData: async ({ commit, dispatch, rootState }) => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        const response = await axios.get(
          `${rootState.axios.API}user/CurrentUserData`,
          {
            headers: {
              Authorization: `Bearer ${rootState.user.data.auth._lat}`,
            },
          }
        );
        localStorage.setItem("currentUserData", JSON.stringify(response.data));
        commit("setUserData", { ...response.data });
        return response.data;
      }
    });
  },
  logout: ({ commit }) => {
    auth.signOut();
    commit("setUser", { auth: null });
    commit("setUserData", {});
    localStorage.setItem("currentUserData", JSON.stringify({ auth: null }));

    if (router.currentRoute.name != "Home") {
      router.push(`/`);
    }
  },
  setRedirectLogin: ({ commit }, val) => {
    commit("setRedirect", val);
    router.push("/login");
  },
};
